/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Delete_Account_Body_Email_DirectionsInputs */

const en_delete_account_body_email_directions = /** @type {(inputs: Delete_Account_Body_Email_DirectionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Check your email for directions on completing your account deletion.`)
};

const es_delete_account_body_email_directions = /** @type {(inputs: Delete_Account_Body_Email_DirectionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Revisa tu correo electrónico para ver las instrucciones sobre cómo completar la eliminación de tu cuenta.`)
};

const ar_delete_account_body_email_directions = /** @type {(inputs: Delete_Account_Body_Email_DirectionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تحقق من بريدك الإلكتروني للحصول على التعليمات الخاصة بإكمال حذف حسابك.`)
};

/**
* | output |
* | --- |
* | "Check your email for directions on completing your account deletion." |
*
* @param {Delete_Account_Body_Email_DirectionsInputs} inputs
* @param {{ locale?: "en" | "es" | "ar" }} options
* @returns {LocalizedString}
*/
export const delete_account_body_email_directions = /** @type {((inputs?: Delete_Account_Body_Email_DirectionsInputs, options?: { locale?: "en" | "es" | "ar" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Delete_Account_Body_Email_DirectionsInputs, { locale?: "en" | "es" | "ar" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_delete_account_body_email_directions(inputs)
	if (locale === "es") return es_delete_account_body_email_directions(inputs)
	return ar_delete_account_body_email_directions(inputs)
});